import React from 'react';
import { Typography } from '@material-ui/core';
import { useInputStyles } from '../../../shared/components/UploadStyles';
import { HomeContext } from '../../Home/HomeContext';

export default function InfluencerWelcomeMessage() {
    const homeContext = React.useContext(HomeContext);
    const classes = useInputStyles();

    const welcomeMessages: Record<string, { title: string; description: string }> = {
        default: {
            title: 'Bem-vindo à plataforma de Análise!',
            description: 'Aqui você pode consultar e submeter perfis de figuras públicas, campanhas e empresas.',
        },
        BoticarioInfluencer: {
            title: 'Bem-vindo(a) à Plataforma de Análises Reputacionais!',
            description: 'Aqui você pode solicitar e consultar análises de perfis de figuras públicas, campanhas, projetos, empresas, eventos ou patrocínios.',
        },
    };

    const clientEnable = homeContext.influencerClientEnable?.nome;
    const clientName = clientEnable || '';

    // Verifica se o nome do cliente contém "boticário" (case-insensitive)
    const getMessageKey = (clientName: string): string => {
        if (clientName.toLowerCase().includes('boticário') || clientName.toLowerCase().includes('boticário')) {
            return 'BoticarioInfluencer';
        }
        return 'default';
    };

    const messageKey = getMessageKey(clientName);
    const { title, description } = welcomeMessages[messageKey];


    return (
        <>
            <Typography variant="h4" className={classes.title}>
                {title}
            </Typography>
            <Typography variant="body1" className={classes.item}>
                {description}
            </Typography>
        </>
    );
}